import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from 'vue'
import { storeToRefs } from 'pinia'
import type { AuthRequest } from '@/stores/auth'
import { AuthPage, useAuthStore } from '@/stores/auth'
import InputText from '@/components/input/InputText.vue'
import AlertMessageContainer from '@/components/AlertMessageContainer.vue'
import MaintenanceNotification from '@/auth/components/MaintenanceNotification.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const authStore = useAuthStore()

const {
  // state
  email,
  password,
  page,
  showPassword,
  hasValidationError,
  requestMessage,
  // actions
  togglePassword,
} = storeToRefs(authStore)

const browserSupported = ref<boolean>(true)

onBeforeMount(() => {
  if (!navigator.userAgentData?.brands?.some(b => b.brand === 'Google Chrome')) {
    browserSupported.value = false
  }
})

const submitForm = async () => {
  if (!email.value || !password.value) return

  return await authStore.login()
    .then((response: AuthRequest) => {
      // User has two factor authentication enabled
      if (response.data.two_factor) {
        page.value = AuthPage.TWO_FACTOR_AUTH
        return
      }

      // redirects to the desired page when user is authenticated
      location.reload()
    })
    .catch((e) => {
      if (e?.response?.status === 422) {
        hasValidationError.value = true

        requestMessage.value = e.response.data.message ?? 'Er is iets misgegaan tijdens het inloggen.'
        return
      }

      console.error(e)
    })
}

return { __sfc: true,authStore, email, password, page, showPassword, hasValidationError, requestMessage, togglePassword, browserSupported, submitForm, AuthPage, InputText, AlertMessageContainer, MaintenanceNotification }
}

})